import dollarImg from "~/assets/deal-feed/dollar-sign.svg";
import giftImg from "~/assets/deal-feed/gift.svg";
import arrowRightImg from "~/assets/deal-feed/arrow-right.svg";
import { Link } from "react-router";
import type { DealClientListData } from "~/types/deal";
import { DealCard } from "~/components/common/DealCard";
import { useBudgetDealsStore, useSubsidyDealsStore } from "~/lib/stores/trending-deals";
import { buildBudgetChannel, buildSubsidyChannel } from "~/lib/deal-channel";
import { useFetchOnce } from "~/lib/hooks/useFetchOnce";

function TrendingItemRow({ deals }: { deals?: DealClientListData[] }) {
  const items = (deals || []).slice(0, 4);
  return (
    <div className="flex w-full gap-4">
      {(items.length > 0 ? items : new Array(4).fill(null)).map((deal, i) => (
        <div
          key={deal?._id || i}
          className="flex min-h-px min-w-px grow basis-0 flex-col items-start justify-start gap-1"
        >
          {deal ? (
            <DealCard
              deal={deal}
              onClick={() => {
                let url = `/deal/detail?deal_id=${deal._id}`;
                if (deal.reqId) {
                  url += `&req_id=${deal.reqId}`;
                }
                window.open(url, "_blank");
              }}
              variant="trending"
            />
          ) : (
            <div className="relative aspect-square w-full overflow-hidden rounded-[24px] bg-gray-100" />
          )}
        </div>
      ))}
    </div>
  );
}

export default function Trending({ tabId }: { tabId?: string }) {
  const { deals: budgetDeals, isLoading: isBudgetLoading, fetchForYouDeals: fetchBudget } = useBudgetDealsStore();
  const { deals: subsidyDeals, isLoading: isSubsidyLoading, fetchDeals: fetchSubsidy } = useSubsidyDealsStore();

  useFetchOnce(
    "trending-budget-for-you",
    () => {
      const budgetChannel = buildBudgetChannel(undefined, tabId);
      fetchBudget(budgetChannel);
    },
    !isBudgetLoading
  );

  useFetchOnce(
    "trending-subsidy-deals",
    () => {
      const subsidyChannel = buildSubsidyChannel(undefined, tabId);
      fetchSubsidy(undefined, subsidyChannel);
    },
    !isSubsidyLoading
  );
  return (
    <div className="flex flex-row items-center justify-between gap-[24px]">
      <div
        id="budget-deals"
        className="flex w-full flex-col justify-between gap-[24px] rounded-[24px] bg-[#FFF6EE] p-[16px]"
      >
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center gap-1">
            <img src={dollarImg} alt="Budget" width={20} height={21} />
            <Link
              to="/shop/budget-deals"
              className="cursor-pointer transition-opacity hover:opacity-80"
              style={{
                fontWeight: "600",
                fontStyle: "SemiBold",
                fontSize: "20px",
                lineHeight: "24px",
                letterSpacing: "0%",
              }}
            >
              Budget Deals
            </Link>
          </div>
          <Link
            to="/shop/budget-deals"
            className="transition-transform hover:translate-x-0.5"
            aria-label="See all Budget Deals"
          >
            <img src={arrowRightImg} alt="Go" width={16} height={17} />
          </Link>
        </div>
        <TrendingItemRow deals={budgetDeals} />
      </div>
      <div
        id="subsidy-program"
        className="flex w-full flex-col justify-between gap-[24px] rounded-[24px] bg-[#ECF9FF] p-[16px]"
      >
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-center gap-1">
            <img src={giftImg} alt="Subsidy" width={20} height={21} />
            <Link
              to="/shop/subsidy-program"
              className="cursor-pointer transition-opacity hover:opacity-80"
              style={{
                fontWeight: "600",
                fontStyle: "SemiBold",
                fontSize: "20px",
                lineHeight: "24px",
                letterSpacing: "0%",
              }}
            >
              Brand Deals
            </Link>
          </div>
          <Link
            to="/shop/subsidy-program"
            className="transition-transform hover:translate-x-0.5"
            aria-label="See all Subsidy Program deals"
          >
            <img src={arrowRightImg} alt="Go" width={16} height={17} />
          </Link>
        </div>
        <TrendingItemRow deals={subsidyDeals} />
      </div>
    </div>
  );
}
